// @flow

import {PathGenerator} from '../PathGenerator/path-generator'
import {traceAll} from '../tracer'
import type {Enkeltmandat} from '../../../../domain/result'

type SvgHelperOptions = {
  rows: number,
  columns: number,
  radius: number,
  spacing: number, // Spacing between circles
  marginHorizontal: number,
  marginVertical: number,
  offsetColumn?: number
}

export class SvgHelper {
  rows: number
  columns: number
  radius: number
  spacing: number
  marginHorizontal: number
  marginVertical: number
  offsetColumn: ?number

  // calculated

  colwidth: number
  width: number
  height: number

  pathGenerator: PathGenerator

  constructor(options: SvgHelperOptions) {
    const {
      columns,
      rows,
      radius,
      spacing,
      marginHorizontal,
      marginVertical,
      offsetColumn
    } = options
    this.rows = rows
    this.columns = columns
    this.radius = radius
    this.spacing = spacing
    this.marginHorizontal = marginHorizontal
    this.marginVertical = marginVertical
    this.offsetColumn = offsetColumn

    this.colwidth = 2 * radius + spacing

    this.width = columns * this.colwidth - spacing + 2 * marginHorizontal
    this.height = rows * this.colwidth - spacing + 2 * marginVertical

    this.pathGenerator = new PathGenerator(
      radius,
      spacing,
      marginHorizontal,
      marginVertical
    )
  }

  traceOutlines(table: Array<Array<Enkeltmandat>>) {
    return traceAll(table).map(({kortNavn, moves}) => ({
      kortNavn,
      path: this.pathGenerator.toPath(moves)
    }))
  }

  getClippedWidth(table: Array<Array<Enkeltmandat>>) {
    const columns = table.findIndex(column => column.every(entry => !entry))
    return columns * this.colwidth + this.spacing
  }

  getCircle(col: number, row: number) {
    const x = this.marginHorizontal + this.radius + col * this.colwidth
    let y = this.marginVertical + this.radius + row * this.colwidth

    if (this.offsetColumn && col === this.offsetColumn) {
      y -= this.colwidth / 2
    }

    return {x, y, r: this.radius}
  }

  getDimensions() {
    return {width: this.width, height: this.height}
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/mandat-svg/SvgHelper/index.js